
export { landingPageDataModify } from "./graphqlDataModify.utils"
export { default as minifyQuery } from "./minifyQuery.utils"
export { thumbnailSectionDataModify } from "./dataFetcherModify.utils"